module.exports = __webpack_public_path__ + "img/vjetrenjaca-1.013a049a.jpg";